import { RuleStatus, ValidationSummary } from '@amzn/awscat-portfolio-assessment-types';
import {
    Box,
    Checkbox,
    CheckboxProps,
    Icon,
    Link,
    NonCancelableCustomEvent,
    Popover,
    SpaceBetween,
} from '@amzn/awsui-components-react';

import { constants } from '../../common/Localization';
import { impactOptions } from './data-quality-constants';
import { getImpactBadgeClassNames, getIssueCount, getSeverity, getSeverityLabel } from './data-quality-helper';
import { RuleToDisplay } from './DataQualityRuleValidation';

interface DataQualityRuleValidationListItemProps {
    rule: RuleToDisplay;
    ruleSelectedChanged: (rule: RuleToDisplay) => (event: NonCancelableCustomEvent<CheckboxProps.ChangeDetail>) => void;
    validationSummary: ValidationSummary;
    editRule: (ruleId: string) => () => void;
    filterInvalidRecords: (ruleId: string) => void;
}

const DataQualityRuleValidationListItem = (
    { rule, ruleSelectedChanged, editRule, filterInvalidRecords, validationSummary }: DataQualityRuleValidationListItemProps
) => {

    return (
        <li className="validation-row" key={rule.ruleId}>
            <div><Checkbox checked={rule.selected} onChange={ruleSelectedChanged(rule)}/></div>
            <div>
                <Popover
                    triggerType="text"
                    content={rule.description}
                >
                    <strong>{rule.name}</strong>
                    {rule.isDefault ? null : <span className="is-custom-rule">{constants.CUSTOM}</span>}
                </Popover>
            </div>
            {
                impactOptions.map(impact => 
                    <div key={impact.id}><span 
                        className={getImpactBadgeClassNames(validationSummary, rule, impact.id)}
                    >
                        {getSeverityLabel(getSeverity(rule, impact.id))}
                    </span></div>
                )
            }
            <div>
                {getIssueCount(validationSummary, rule)}
                <Box float='right' padding={{ right: 'l' }}>
                    <SpaceBetween size="xs" direction='horizontal'>
                        <Link onFollow={editRule(rule.ruleId)}><Icon name="edit" variant="link"/></Link>
                        { validationSummary.rules[rule.ruleId] > 0 && rule.status === RuleStatus.ACTIVE ? (
                            <Link onFollow={() => filterInvalidRecords(rule.ruleId)}><Icon name="filter" variant="link"/></Link>
                        ) : (null)
                        }
                    </SpaceBetween>
                </Box>
            </div>
        </li>
    );
};

export default DataQualityRuleValidationListItem;
